export default async function (activity: object, sync = false) {
    const activities = useState('activities', () => []);

    const platform = useState('platform');
    const userAuth = useCookie('auth_token', { readonly: true, default: () => false })

    activities.value.push(activity);

    async function sendActivities() {
        if (activities.value.length === 0 && import.meta.server) return

        const batch = [...activities.value]
        activities.value = []

        if (!localStorage.getItem('auth-activity-token')) {
            localStorage.setItem('auth-activity-token', `"${crypto.randomUUID()}"`)
        }
        // TODO: old token fix — safe to remove after some time
        if (!localStorage.getItem('auth-activity-token').startsWith('"')) {
            localStorage.setItem('auth-activity-token', `"${localStorage.getItem('auth-activity-token')}"`)
        }

        const token = JSON.parse(localStorage.getItem('auth-activity-token'));

        try {
            await $api('/activity', {
                method: 'POST',
                body: {
                    activities: batch,
                    token: token,
                },
                headers: {
                    'x-api-key': platform.value.api_key,
                    'Authorization': userAuth.value ? `Bearer ${userAuth.value}` : null
                },
            });
        } catch (error) {
            throw error
            activities.value.unshift(...batch)
        }
    }

    if (sync) {
        await sendActivities()
    } else {
        const interval = setInterval(async () => {
            if (activities.value.length > 0) {
                await sendActivities()
            }
        }, 100);

        onBeforeUnmount(() => clearInterval(interval));
    }
}